import api from './axios';

const BASE = '/settings';

export const getSettings = () => api.get(BASE);

export const updateSettings = (data) => api.put(BASE, data);
